const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90B1DE",
      stroke: "#2C3D60",
      strokeWidth: "1.5px"
    },
    d: "M 3,88 3,7 C 3,4 4,3 7,3 l 86,0 c 3,0 4,2 4,5 l 0,85 c 0,2 0,4 -4,4 l -81,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7EC2"
    },
    d: "m 6,6 0,81 7,7 81,0 0,-88 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "#555555",
      strokeWidth: 2
    },
    d: "M 28 62 C 24 62 24 64 24 66 L 24 97 L 76 97 L 76 66 C 76 64 75 62 72 62 L 28 62 z M 38 66 C 45 66 44 69 44 69 L 44 87 C 44 87 45 90 38 90 C 32 90 33 87 33 87 L 33 69 C 33 69 32 66 38 66 z "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 0.7
    },
    width: 66,
    height: 10,
    x: 17,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#eeeeee"
    },
    width: 66,
    height: 42,
    x: 17,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2C3D60"
    },
    width: 6,
    height: 6,
    x: 8,
    y: 9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#bbbbbb",
      strokeWidth: 2
    },
    d: "m 21,47 58,0 M 21,35 79,35 M 21,24 79,24"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1bfce19bee927ad607c794f6e6814981.svg";
export { ForwardRef as ReactComponent };